import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { I18nProvider } from "@/i18n/I18nContext";
import ScrollToTop from "@/components/ScrollToTop";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import ThankYou from "@/pages/ThankYou";
import { PrivacyPolicy, CookiePolicy, Terms } from "@/pages/Legal";

function LocalizedLayout() {
  return (
    <I18nProvider>
      <div className="min-h-screen flex flex-col bg-[#F8F9FA]">
        <Header />
        <div className="flex-1">
          <Outlet />
        </div>
        <Footer />
        <CookieBanner />
      </div>
    </I18nProvider>
  );
}

function ThankYouLayout() {
  // Thank You must be Spanish-only, no header/footer language switcher context.
  // We still render header/footer, but forced to Spanish by wrapping in I18nProvider
  // whose lang is derived from URL. Our route is /thank_you so it will fall back to DEFAULT_LANG=mx.
  return (
    <I18nProvider>
      <div className="min-h-screen flex flex-col bg-[#F8F9FA]">
        <Header />
        <div className="flex-1">
          <ThankYou />
        </div>
        <Footer />
        <CookieBanner />
      </div>
    </I18nProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to="/mx" replace />} />
          <Route path="/thank_you" element={<ThankYouLayout />} />

          <Route path="/mx" element={<LocalizedLayout />}>
            <Route index element={<Home />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="cookie-policy" element={<CookiePolicy />} />
            <Route path="terms" element={<Terms />} />
          </Route>

          <Route path="/en" element={<LocalizedLayout />}>
            <Route index element={<Home />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="cookie-policy" element={<CookiePolicy />} />
            <Route path="terms" element={<Terms />} />
          </Route>

          <Route path="*" element={<Navigate to="/mx" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
